import React from "react";
import AllTriggersManagement from "@/components/admin/communication-hub/AllTriggersManagement";

const CommunicationTriggersManagement: React.FC = () => {
  return (
    <div className="space-y-6">
      <AllTriggersManagement />
    </div>
  );
};

export default CommunicationTriggersManagement;
